// extracted by mini-css-extract-plugin
export default {"Avatar":"UserLogin_Avatar__WUwDt","switchTenantDialog":"UserLogin_switchTenantDialog__uwddF"};